import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import { selectUser } from "../../components/auth/auth.selector";
import HelmetWrapper from "../../HelmetWrapper";
import SearchNButtons from "../../components/common-components/SearchNButtons";
import CommonStructured from "../../components/common-components/CommonStructured";
import { fetchDashboardMenusdata } from "../../redux/dashboard-features/featuresSlice";
import DashMenuForm from "../../components/feature-control/menus/DashMenuForm";
import DashMenuListings from "../../components/feature-control/menus/DashMenuListings";
import PaymentLinkTable from "../../components/payment-link-system/PaymentLinkTable";
import ModalHeadAndClose from "../../components/payouts-wtf/common/ModalHeadAndClose";
import { CheckCircleIcon, CrossCircleIcon } from "../../images/icons/icons";

const DashboardMenus = () => {
  const userInfoData = useSelector(selectUser);
  const dispatch = useDispatch();

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    isActive: "",
    selectedSequence: "",
    selectedMenus: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    status: allFilters.isActive?.value || "",
    sequence_no: allFilters.selectedSequence?.value || "",
    menu_id: allFilters.selectedMenus?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const iniModvalues = {
    isModOpen: false,
    cardName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  const onCloseModal = () => {
    setModValues(iniModvalues);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getDashboardMenus(filters) {
    dispatch(
      fetchDashboardMenusdata({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getDashboardMenus(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      status: allFilters.isActive?.value || "",
      sequence_no: allFilters.selectedSequence?.value || "",
      menu_id: allFilters.selectedMenus?.value || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.isActive,
    allFilters.selectedSequence,
    allFilters.selectedMenus,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  const tbColumns = [
    {
      dataField: "uid",
      text: "feature name",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.name || "NA"}</span>;
      },
    },
    {
      dataField: "route",
      text: "route",
      formatter: (cell, row) => {
        return <span className="tb-data lowercase">{row?.route || "-"}</span>;
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cell, row) => {
        return (
          <span className="tb-data icon">
            {row?.status ? (
               <CheckCircleIcon />
            ) : (
              <CrossCircleIcon />
            )}
          </span>
        );
      },
    },
  ];

  return (
    <HelmetWrapper title="WTF: Dashboard Menus">
      <Container className="bg-cloud-k px-50px" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Modal"
          ariaHideApp={false}
        >
          {modValues.cardName === "add" || modValues.cardName === "edit" ? (
            <DashMenuForm
              userInfoData={userInfoData}
              rowData={modValues.rowData}
              isEdit={modValues.cardName === "edit"}
              closeModal={onCloseModal}
              callFunction={() => getDashboardMenus(filters)}
            />
          ) : modValues.cardName === "features_mapped" ? (
            <div className="createNewCTOModalContainer mod-width-50p">
              <ModalHeadAndClose
                title={`${modValues.cardName?.replace(/_/g, " ")}`}
                onClose={onCloseModal}
              />

              <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30">
                <PaymentLinkTable
                  tableData={modValues.rowData?.features}
                  tableColumns={tbColumns}
                />
              </div>
            </div>
          ) : null}
        </Modal>

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Dashboard Menus"}
              createBtnTxt={"+ Add New Dashboard Menu"}
              onClickCreateBtn={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardName: "add",
                }))
              }
              isReload={() => getDashboardMenus(filters)}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <SearchNButtons
              pageName={"dash-features"}
              filters={allFilters}
              setFilters={setAllFilters}
              searchFilterApplied={searchFilterApplied}
              onClickSearch={onClickSearch}
              userInfoData={userInfoData}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <DashMenuListings
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              setModValues={setModValues}
              callFunction={() => getDashboardMenus(filters)}
              userInfoData={userInfoData}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default DashboardMenus;
